import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { User } from 'src/app/calvin-emr-shared/models/user.model';
import { PatientService } from 'src/app/calvin-emr-shared/services/patient.service';
import { PATH_STUDENTS, PATH_VIEW_STUDENT_PATIENT } from '../students.global';
import { TableModule } from 'primeng/table';
import { PrimeTemplate } from 'primeng/api';
import { ButtonDirective } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-student-dialog',
    templateUrl: './student-dialog.component.html',
    styleUrls: ['./student-dialog.component.scss'],
    standalone: true,
    imports: [
        TableModule,
        PrimeTemplate,
        ButtonDirective,
        TooltipModule,
    ],
})
export class StudentDialogComponent implements OnInit {
  public ref = inject(DynamicDialogRef);
  public config = inject(DynamicDialogConfig);
  private patientService = inject(PatientService);
  private router = inject(Router);

  isLoading = false;

  /**
   * The student object being examined in the dialog.
   */
  student: User = new User();

  patients: Patient[] = [];

  constructor() {
    this.isLoading = true;
    this.student = this.config.data;
    this.patientService.getPatientsForUser(this.student).subscribe((patients: Patient[]) => {
      this.patients = patients;
      this.isLoading = false;
    });
  }

  ngOnInit(): void {}

  navigateToPatient(id: string) {
    this.ref.close();
    this.router.navigate([PATH_STUDENTS, PATH_VIEW_STUDENT_PATIENT, id]);
  }
}
